export default __webpack_public_path__ + "static/media/8.da0982fd.png";